import { parse } from "papaparse"
import { BatchItem } from "./BatchItem"

export class CsvFile {
    public allowedHeaders: string[]

    static pruneHeader(header: string) {
        return header.trim().toLowerCase()
    }

    constructor(private file: File, allowedHeaders: string[] = ["name", "source"]) {
        this.allowedHeaders = allowedHeaders.map(header => CsvFile.pruneHeader(header))
    }

    hasValidHeaders(): Promise<boolean> {
        return new Promise((resolve, reject) => {
            parse(this.file, {
                skipEmptyLines: true,
                complete: ({ data, errors, meta }) => {
                    if (errors.length) {
                        reject(errors)
                    } else {
                        const result = data as string[][]
                        const columns: string[] = result[0].map((header: string) =>
                            CsvFile.pruneHeader(header)
                        )
                        for (const header of this.allowedHeaders) {
                            if (!columns.includes(header)) {
                                resolve(false)
                            }
                        }
                        resolve(true)
                    }
                }
            })
        })
    }

    toJson(): Promise<BatchItem[]> {
        return new Promise((resolve, reject) => {
            parse(this.file, {
                header: true,
                skipEmptyLines: true,
                complete: result => {
                    if (result.errors.length) {
                        reject(result.errors)
                    } else {
                        const data = result.data.map(item => {
                            return Object.entries(item as object).reduce((acc, [key, value]) => {
                                //@ts-ignore
                                acc[CsvFile.pruneHeader(key)] = value
                                return acc
                            }, {} as BatchItem)
                        }, [] as BatchItem[])
                        resolve(data as BatchItem[])
                    }
                }
            })
        })
    }
}
